import React from 'react'
import PropTypes from 'prop-types'
import styles from './_personalProgress2018.css'
import { FormattedMessage } from 'react-intl'
import convert from 'shared/units/convert'
import Title from 'components/landing/shared/Title'
import Svg from 'components/util/Svg'
import awards from 'images/year-in-review/2018/midyear/icons/awards-blue.png'
import workout from 'images/year-in-review/2018/midyear/icons/workout-blue.png'
import distance from 'images/year-in-review/2018/midyear/icons/distance-blue.png'
import time from 'images/year-in-review/2018/midyear/icons/time-blue.png'
import pace from 'images/year-in-review/2018/midyear/icons/pace-blue.png'
import calories from 'images/year-in-review/2018/midyear/icons/calories-blue.png'

function Personal (props) {
  const {
    username,
    userYear,
    userUnitPreference,
    onTwitterShare,
    onFacebookShare,
    firstName,
  } = props

  const isImperial = userUnitPreference === 'imperial'

  const awardCount = userYear.challenges.number_of_awards

  const totalWorkouts = userYear.all.total_workouts ? userYear.all.total_workouts.value : null

  const totalMeters = userYear.all.total_distance ? userYear.all.total_distance.value : null
  const distanceValue = totalMeters
    ? isImperial ? convert(totalMeters).from('meter').to('mile') : totalMeters / 1000
    : null

  const totalSeconds = userYear.all.total_duration ? userYear.all.total_duration.value : null
  const totalHours = totalSeconds ? convert(totalSeconds).from('second').to('hour') : null

  const ridePace = userYear.ride.fastest_pace ? userYear.ride.fastest_pace.value : null
  const fastestRide = ridePace ? (1 / ridePace) * (isImperial ? 2.237 : 3.6) : 0

  const runPace = userYear.run.fastest_pace ? userYear.run.fastest_pace.value : null
  const fastestRun = runPace ? runPace / 60 * (isImperial ? 1609.34 : 1000) : null

  const longestMeters = userYear.all.longest_distance ? userYear.all.longest_distance.value : null

  const longestDistance = longestMeters
    ? isImperial ? convert(longestMeters).from('meter').to('mile') : longestMeters / 1000
    : null

  const totalJoules = userYear.all.total_energy_expended ? userYear.all.total_energy_expended.value : null
  const totalCalories = totalJoules ? convert(totalJoules).from('joules').to('kilocalorie') : null

  return (
    <div className={styles.personal}>
      <Title align="center">
        <FormattedMessage
          id='midyear.2018.personal.title'
          defaultMessage={`{ firstName }, review the last 6 months.\nThen keep going.`}
          values={ { firstName } }
        />
      </Title>
      <div className={styles.statsContainer}>
        { username ?
          <img
            className={styles.profile}
            src={`/profile/${username}/picture?size=Medium`}
          />
        : null }
        <div className={styles.stats}>

          { awardCount ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={awards} className={styles.icon} />
              </div>
              <p className={styles.statValue}>{awardCount}</p>
              <p className={styles.statUnit}>
                <FormattedMessage
                  id='midyear.2018.personal.challenge_awards'
                  defaultMessage='Awards Achieved'
                />
              </p>
            </div>
          : null }

          { totalWorkouts ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={workout} className={styles.icon} />
              </div>
              <p className={styles.statValue}>{totalWorkouts}</p>
              <p className={styles.statUnit}>
                <FormattedMessage
                  id='midyear.2018.personal.total_workouts'
                  defaultMessage='Total Workouts Logged'
                />
              </p>
            </div>
          : null }

          { distanceValue ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={distance} className={styles.icon} />
              </div>
              <p className={styles.statValue}>
                { distanceValue.toLocaleString(undefined, { maximumFractionDigits: 0 }) }
              </p>
              <p className={styles.statUnit}>
                {
                  isImperial
                    ? <FormattedMessage
                      id='midyear.2018.personal.total_miles'
                      defaultMessage='Miles Logged'
                    />
                    : <FormattedMessage
                      id='midyear.2018.personal.total_kilometers'
                      defaultMessage='Kilometers Logged'
                    />
                }
              </p>
            </div>
          : null }

          { totalHours ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={time} className={styles.icon} />
              </div>
              <p className={styles.statValue}>
                { totalHours.toLocaleString(undefined, { maximumFractionDigits: 0 }) }
              </p>
              <p className={styles.statUnit}>
                <FormattedMessage
                  id='midyear.2018.personal.total_duration'
                  defaultMessage='Total Hours Logged'
                />
              </p>
            </div>
          : null }

          { fastestRide ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={pace} className={styles.icon} />
              </div>
              <p className={styles.statValue}>
                { fastestRide.toLocaleString(undefined, { maximumFractionDigits: 2 }) }
              </p>
              <p className={styles.statUnit}>
                {
                  isImperial
                    ? <FormattedMessage
                      id='midyear.2018.personal.fastest_ride_imperial'
                      defaultMessage='Fastest Ride (mph)'
                    />
                    : <FormattedMessage
                      id='midyear.2018.personal.fastest_ride_metric'
                      defaultMessage='Fastest Ride (km/h)'
                    />
                }
              </p>
            </div>
          : null }

          { fastestRun ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={pace} className={styles.icon} />
              </div>
              <p className={styles.statValue}>
                { fastestRun.toLocaleString(undefined, { maximumFractionDigits: 2 }) }
              </p>
              <p className={styles.statUnit}>
                {
                  isImperial
                    ? <FormattedMessage
                      id='midyear.2018.personal.fastest_run_imperial'
                      defaultMessage='Fastest Run (min/mile)'
                    />
                    : <FormattedMessage
                      id='midyear.2018.personal.fastest_run_metric'
                      defaultMessage='Fastest Run (min/km)'
                    />
                }
              </p>
            </div>
          : null }

          { longestDistance ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={distance} className={styles.icon} />
              </div>
              <p className={styles.statValue}>
                { longestDistance.toLocaleString(undefined, { maximumFractionDigits: 2 }) }
              </p>
              <p className={styles.statUnit}>
                {
                  isImperial
                    ? <FormattedMessage
                      id='midyear.2018.personal.longest_miles'
                      defaultMessage='Longest Distance (miles)'
                    />
                    : <FormattedMessage
                      id='midyear.2018.personal.longest_kilometers'
                      defaultMessage='Longest Distance (km)'
                    />
                }
              </p>
            </div>
          : null }

          { totalCalories ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={calories} className={styles.icon} />
              </div>
              <p className={styles.statValue}>
                { totalCalories.toLocaleString(undefined, { maximumFractionDigits: 0 }) }
              </p>
              <p className={styles.statUnit}>
                <FormattedMessage
                  id='midyear.2018.personal.total_calories'
                  defaultMessage='Total Calories Burned'
                />
              </p>
            </div>
          : null }
        </div>
      </div>
      <ul className={styles.socialLinks}>
        <li onClick={onFacebookShare}>
          <Svg name='facebook' width={24} height={24} fill='#9fa1a4' />
        </li>
        <li onClick={onTwitterShare}>
          <Svg name='twitter' width={24} height={24} fill='#9fa1a4' />
        </li>
      </ul>
    </div>
  )
}

Personal.propTypes = {
  onFacebookShare: PropTypes.func,
  onTwitterShare: PropTypes.func,
  userUnitPreference: PropTypes.string,
  userYear: PropTypes.object,
  username: PropTypes.string,
  firstName: PropTypes.string,
}

export default Personal



// WEBPACK FOOTER //
// ./src/components/yearInReview/2018/midyear/PersonalProgress/index.js